"use strict";
exports.__esModule = true;
exports.EMBED_BALANCE_OUT_OF_RANGE = void 0;
exports.EMBED_BALANCE_OUT_OF_RANGE = {
    VALIDATOR_CONFIG: {
        min: 0,
        max: 10000
    },
    NEGATIVE_AMOUNT_ERROR_TEXT: 'Amount must be greater than zero',
    MAX_AMOUNT_ERROR_TEXT: 'Amount must be less than $10,000.00',
    NOT_A_NUMBER_ERROR_TEXT: 'Amount must be a number',
    BILLER_EXCEEDED_AMOUNT_DUE_ERROR: 'Payment can’t exceed amount due'
};
